import { render } from "./TooltipButton.vue?vue&type=template&id=7c48214c"
import script from "./TooltipButton.vue?vue&type=script&lang=js"
export * from "./TooltipButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__